export default __webpack_public_path__ + "static/media/logo_qc.c4db4246.png";